import React, { useState } from "react";
import { connect } from "react-redux";
import { Container } from "reactstrap";
import { H2, P } from "../../AbstractElements";
import { changeTab as changeTabAction } from "../../ReduxToolkit/Reducers/analytics";
import BrandsAnalytics from "../../Components/Analytics/BrandsAnalytics";
import RetailersAnalytics from "../../Components/Analytics/RetailersAnalytics";
import DataQualityFunnel from "../../Components/Analytics/DataQualityFunnel";

const tabOptions = [
  { label: "Brands", value: "Brands" },
  { label: "Retailers", value: "Retailers" },
];

const Analytics = ({ tabState, changeTab }) => {
  const [tab, setTab] = useState(tabState || "Italy");

  return (
    <Container className="default-dashboard p-3" fluid>
      <div style={{ marginBottom: "20px" }}>
        <H2>Dashboard:</H2>
        <P
          className="mb-0 fw-medium text-title-gray"
          style={{ fontSize: "18px", color: "#485C74" }}
        >
          Data-driven insights for brands and retailers across global fashion market
        </P>
      </div>

      <div style={{ display: "flex", borderRadius: "10px", overflow: "hidden", width: "100%", border: '1px solid #E5E7EB', backgroundColor: "#F2F4F6" }}>
        {tabOptions.map((t, i) => (
          <div
            key={t.value}
            onClick={() => {
              setTab(t.value)
              changeTab(t.value)
            }}
            style={{
              padding: "18px",
              cursor: "pointer",
              backgroundColor: tab === t.value ? "#2A2F38" : "#F2F4F6",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              width: '100%'
            }}
          >
            <p
              style={{
                fontWeight: 'bolder',
                fontSize: "20px",
                margin: 0,
                color: tab === t.value ? "#fff" : "#2A2F38",
              }}>
              {t.label}
            </p>
          </div>
        ))}
      </div>

      {/* <DataQualityFunnel key={tab} tab={tab} /> */}

      {tab === 'Brands' && <BrandsAnalytics />}
      {tab === 'Retailers' && <RetailersAnalytics />}
    </Container>
  );
};

const mapStateToProps = (state) => ({
  tabState: state.analytics.tab,
});

const mapDispatchToProps = {
  changeTab: changeTabAction,
};

export default connect(mapStateToProps, mapDispatchToProps)(Analytics);
